import styled from "styled-components";
import { WrapperContainer } from "../../../../../../../../components";

export const SimpleListSectionStyled = styled(WrapperContainer)`
  ul {
    list-style: disc;
    display: flex;
    flex-direction: column;
    gap: 4px;

    margin-left: 24px;

    li {
      line-height: 24px;
    }
  }
`;
